import Vue from 'vue'
import Router from 'vue-router'
import cxcs from '@/components/cxcs.vue'
import cxjg from '@/components/cxjg.vue'
import { resolve } from 'q';

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'cxcs',
      component: cxcs
    },
    {
      path:'/cxjg',
      name:'cxjg',
      component:cxjg
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js